module.exports = "<div ng-class=\"['search-wrapper', {border: $ctrl.hasBorder}]\">\n    <input type=\"text\" placeholder=\"{{ $ctrl.placeholder }}\" />\n    <i class=\"icon ico-search\"></i>\n</div>\n<!-- .search-wrapper END-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpSearchInput/adpSearchInput.html
// module id = 645
// module chunks = 0